import React, { useEffect, useState, useRef } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import { CHeaderNav } from '@coreui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import defaultAvathar from "../../src/assets/images/default-avatar.png"
import PropTypes from 'prop-types';
import { userLogout } from '../reducers/authReducer';
import { useAuth0 } from '@auth0/auth0-react';
import { getPermissions } from "../reducers/permissionsReducer";
import { Button } from 'antd';
import Switecher from './switcher';
import { BarChartOutlined } from '@ant-design/icons';
import apiCalls from 'src/api/apiCalls';
import AnalyticsDrawer from './Analytics';


const AppHeader = (props) => {
  const dispatch = useDispatch();
  const UserProfile = useSelector(state => state.oidc?.user)
  const adminDetails = useSelector(state => state.oidc?.adminDetails)
  const adminProfileImg = useSelector(state => state.oidc?.adminProfileImg);
  const menuItems = useSelector((store) => store?.permissions?.menuItems)
  const navigate = useNavigate();
  const location = useLocation();
  const isAnalytics = menuItems?.some(item => item.isAnalytics && item.path === location.pathname);
  const dropdownRef = useRef(null);


  const [state, setState] = useState({
    isOpen: false,
    isDrawerVisible: false,
    loader: false,
    error: null,
  });

  const toggleDropdown = () => setState(prev => ({ ...prev, isOpen: !prev.isOpen }));


  useEffect(() => {
    if ((props.userProfile?.role == 'Customer'&&!window.location.pathname.includes("/accessdenied"))||(props.userProfile?.customerStatus=="Inactive"&&!window.location.pathname.includes("/accessdenied"))) {
      navigate("/accessdenied")
    }
  }, [location])//eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setState(prev => ({ ...prev, isOpen: false }))
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const redirectToProfile = () => {
    navigate('/userprofile/profile', { state: { type: 'userprofile', isTab: true } })
    toggleDropdown();
  }
  const { logout } = useAuth0()
  const handleLogout = () => {
    dispatch(userLogout());
    window.$zoho?.salesiq?.chat.complete();
    window.$zoho?.salesiq?.reset();
    logout({ logoutParams: { returnTo: process.env.REACT_APP_REDIRECT_URI } });
  };

  const handleAnalyticsDrawer = async () => {
    setState(prev => ({ ...prev, isDrawerVisible: true, loader: true, error: apiCalls.isErrorDispaly(null) }));
  };
  const handleCloseAnalytics = () => {
    setState(prev => ({ ...prev, isDrawerVisible: false, loader: false, error: apiCalls.isErrorDispaly(null) }));
  }

  return (
    <>
      <div className='flex items-center lg:mr-[68px] justify-between'>
        <h3 className='sm:text-sm md:text-lg text-light-primaryColor font-semibold dark:text-dark-primaryColor pl-8 ml-4 md:pl-16 lg:pl-0 lg:ml-0'>{process.env.REACT_APP_CLIENT_NAME}</h3>
        <CHeaderNav className="flex items-center justify-items-center rounded-md gap-0.5" >
          <div className=" tracking-wider">
            <Switecher />
          </div>
          {isAnalytics && <Button
            type="text"
            icon={<BarChartOutlined className='text-light-primaryColor dark:text-dark-primaryColor !text-lg' />}
            onClick={handleAnalyticsDrawer}
            className=""
          />}
          <div className="relative inline-block text-left" ref={dropdownRef}>
            <div>
              <button onClick={toggleDropdown} className="flex items-center justify-center p-1 focus:outline-none rounded-xl">
                <div className="flex items-center gap-1">
                  <div>
                    <img
                      className="w-13 h-13 bg-light-dropdownBg  object-cover rounded-full"
                      src={adminProfileImg || adminDetails?.imageURL || defaultAvathar}
                      alt="profile img"
                    />
                  </div>
                  <div className="text-sm max-sm:hidden font-medium text-light-primaryColor dark:text-dark-primaryColor font-sans">
                    {UserProfile?.userName}
                  </div>
                </div>
              </button>
            </div>
            {state.isOpen && (
              <div className="bg-light-cardBg dark:bg-light-cardBg dark:border-t-dark-primaryColor absolute overflow-hidden right-[4px] top-[52px] w-52 z-10 shadow-sm border border-light-secondaryColor">
                <div className="mt-2 mb-2">
                  <div>
                    <img
                      className="w-22 h-22 mx-auto rounded-full object-cover"
                      src={adminProfileImg || adminDetails?.imageURL || defaultAvathar}
                      alt="profile img"
                    />
                  </div>
                  <h5 className='text-dark-textWhite mt-3 uppercase font-medium text-center leading-normal break-words px-1'>{UserProfile?.userName}</h5>
                  {props.userProfile?.role=="Admin"&&<div className='text-center'>
                    <button
                      className="bg-dark-primaryColor text-light-btntextColor inline-block h-12 px-2 rounded-lg mx-auto my-2 font-medium"
                      onClick={() => redirectToProfile()}
                    >
                      Manage Account
                    </button>
                  </div>}
                </div>

                <button
                  className="w-full text-left hover:bg-light-labelColor"
                  onClick={() => handleLogout()}
                >
                  <h4 className="mb-0 hover:bg-light-kendoHover hover:dark:bg-light-secondaryColor px-1 font-semibold cursor-pointer py-[8px] border-t border-light-secondaryColor text-light-primaryColor">
                    <span className="icon mr-[4px] logout"></span>
                    <span>Logout</span>
                  </h4>
                </button>
              </div>)}
          </div>
        </CHeaderNav>
      </div>
     {state.isDrawerVisible && <AnalyticsDrawer
        isVisible={state.isDrawerVisible}
        onClose={handleCloseAnalytics}
      />}
    </>
  )
}
const connectStateToProps = ({ auth, AdminData, permissions, oidc }) => {
  return { auth: auth, adminType: AdminData.AdminType, permissions, userProfile: oidc.user, menu: AdminData.cardspermissionsconfig, highlightedmenuItem: AdminData.highlightedmenuItem };
};
export default connect(connectStateToProps, (dispatch) => {
  return {
    fetchMenuItemPermissions: (pKey, userId) => {
      dispatch(getPermissions({ customerId: userId, perKey: pKey }));
    },
  };
})(AppHeader);
AppHeader.propTypes = {
  adminType: PropTypes.string,
  userProfile: PropTypes.object,
};
